function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#visa_card_clip)"
}, React.createElement("path", {
  d: "M29.4564 21.6828H23.9497L27.394 0.386169H32.9003L29.4564 21.6828Z",
  fill: "#00579F"
}), React.createElement("path", {
  d: "M49.4184 0.906863C48.3322 0.475957 46.6095 0.000183105 44.4794 0.000183105C39.0414 0.000183105 35.212 2.89999 35.1885 7.04585C35.1433 10.1046 37.9302 11.8036 40.0146 12.8235C42.145 13.8657 42.8692 14.5459 42.8692 15.4749C42.8476 16.9016 41.1477 17.5592 39.5623 17.5592C37.3638 17.5592 36.1858 17.2202 34.3957 16.4264L33.6706 16.0861L32.9 20.8668C34.1915 21.4552 36.571 21.9773 39.0414 22.0002C44.8193 22.0002 48.5809 19.1452 48.6255 14.7272C48.6475 12.3028 47.1759 10.4452 44.0033 8.92726C42.0773 7.95283 40.8978 7.29578 40.8978 6.29876C40.9204 5.39238 41.8954 4.46402 44.0695 4.46402C45.8597 4.41855 47.175 4.84886 48.1714 5.27946L48.6695 5.5056L49.4184 0.906863Z",
  fill: "#00579F"
}), React.createElement("path", {
  d: "M56.7376 14.1381C57.1911 12.9147 58.9361 8.17951 58.9361 8.17951C58.9132 8.22498 59.3887 6.93347 59.6606 6.14062L60.0454 7.97566C60.0454 7.97566 61.0882 13.0734 61.3146 14.1381C60.454 14.1381 57.8252 14.1381 56.7376 14.1381ZM63.5348 0.386169H59.2754C57.9619 0.386169 56.964 0.771004 56.3973 2.15315L48.2179 21.6824H53.9959C53.9959 21.6824 54.9471 19.0539 55.1516 18.4878C55.7854 18.4878 61.4062 18.4878 62.2216 18.4878C62.3797 19.2355 62.8787 21.6824 62.8787 21.6824H67.9773L63.5348 0.386169Z",
  fill: "#00579F"
}), React.createElement("path", {
  d: "M19.3507 0.386169L13.9579 14.9084L13.3686 11.9631C12.3716 8.56465 9.24475 4.87229 5.75534 3.03635L10.695 21.6602H16.5181L25.1735 0.386169H19.3507Z",
  fill: "#00579F"
}), React.createElement("path", {
  d: "M8.95026 0.386169H0.0906375L0 0.816473C6.91106 2.58376 11.4881 6.84373 13.3686 11.964L11.4427 2.17634C11.1256 0.816172 10.1511 0.431037 8.95026 0.386169Z",
  fill: "#FAA61A"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "visa_card_clip"
}, React.createElement("rect", {
  width: 67.9772,
  height: 22,
  fill: "white"
})));

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 68,
    height: 22,
    viewBox: "0 0 68 22",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.658fe55d.svg";
export { ForwardRef as ReactComponent };